module.exports = __webpack_public_path__ + "media/honey-icons/icon-light-da769581.svg";